import {
  aluminiumV1,
  batteryV1,
  chemicalV1,
  detergentV1,
  electronicsV1,
  energyRelatedV1,
  furnitureV1,
  lubricantV1,
  paintV1,
  steelV1,
  textileV1,
  tyreV1,
  withCommonCategories,
} from "@app/dpp-schemas";
import type { PassportSchemaDef } from "@app/dpp-schemas";
import type { Lang } from "../i18n.js";

/**
 * Client-side mirror of the API's schema registry (apps/api/src/lib/
 * schema-registry.ts): id → definition for form rendering and the schema
 * select. New sector templates are registered in both places.
 */

// Every sector template gets the cross-sector "compliance" category
// (substances of concern, conformity documents, voluntary labels) appended —
// the horizontal obligations are the same for every product group.
const SCHEMA_DEFS: Readonly<Record<string, PassportSchemaDef>> = Object.fromEntries(
  [
    textileV1,
    batteryV1,
    furnitureV1,
    steelV1,
    aluminiumV1,
    electronicsV1,
    energyRelatedV1,
    tyreV1,
    detergentV1,
    paintV1,
    lubricantV1,
    chemicalV1,
  ].map((def) => [def.id, withCommonCategories(def)]),
);

/** Undefined for unknown ids — pages render a friendly "unknown schema" state. */
export function getSchemaDef(schemaId: string): PassportSchemaDef | undefined {
  return SCHEMA_DEFS[schemaId];
}

export function schemaOptions(lang: Lang): { label: string; value: string }[] {
  return Object.values(SCHEMA_DEFS).map((def) => ({ label: def.title[lang], value: def.id }));
}

/** Field label lookup ("identity.brand" → localized label) for compliance lists. */
export function fieldLabel(def: PassportSchemaDef | undefined, fieldId: string, lang: Lang): string {
  if (def) {
    for (const category of def.categories) {
      for (const field of category.fields) {
        if (field.id === fieldId) return field.labels[lang];
      }
    }
  }
  return fieldId;
}
